module.exports = __webpack_public_path__ + "static/media/arrow-icon.2b01d61c.svg";